import { getColor } from 'utils/functions';

export const colorGraphUp = '#88E927';
export const colorGraphDown = '#E70E31';

export const ChartColors = [
  getColor('--extended-01-high'),
  getColor('--extended-03-high'),
  getColor('--extended-02-high'),
  getColor('--extended-04-high'),
  getColor('--extended-04-low'),
  getColor('--extended-01-low'),
  getColor('--extended-05-high'),
  getColor('--extended-06-high'),
  getColor('--extended-07-high'),
  getColor('--extended-08-high'),
  getColor('--extended-09-high'),
  getColor('--extended-10-high'),
];
